import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DevicesTypeWithKey } from 'commons/src/models/commonTypeScript';

export type VirtualDevicesState = {
    virtualDevices: DevicesTypeWithKey;
};

const initialState: VirtualDevicesState = {
    virtualDevices: {},
};

const virtualDevices = createSlice({
    name: 'virtualDevices',
    initialState,
    reducers: {
        setVirtualDevices: (state, action: PayloadAction<DevicesTypeWithKey>) => {
            state.virtualDevices = action.payload;
        },
        clearVirtualDevices: state => {
            state.virtualDevices = {};
        },
    },
});

export const { setVirtualDevices, clearVirtualDevices } = virtualDevices.actions;
export default virtualDevices.reducer;
